(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-coroutines-core.js', './kotlinx-atomicfu.js', './okio-parent-okio.js', './skiko-kjs.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-coroutines-core.js'), require('./kotlinx-atomicfu.js'), require('./okio-parent-okio.js'), require('./skiko-kjs.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'coil-root-coil-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'coil-root-coil-core'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'coil-root-coil-core'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'coil-root-coil-core'.");
    }
    if (typeof globalThis['kotlinx-atomicfu'] === 'undefined') {
      throw new Error("Error loading module 'coil-root-coil-core'. Its dependency 'kotlinx-atomicfu' was not found. Please, check whether 'kotlinx-atomicfu' is loaded prior to 'coil-root-coil-core'.");
    }
    if (typeof globalThis['okio-parent-okio'] === 'undefined') {
      throw new Error("Error loading module 'coil-root-coil-core'. Its dependency 'okio-parent-okio' was not found. Please, check whether 'okio-parent-okio' is loaded prior to 'coil-root-coil-core'.");
    }
    if (typeof globalThis['skiko-kjs'] === 'undefined') {
      throw new Error("Error loading module 'coil-root-coil-core'. Its dependency 'skiko-kjs' was not found. Please, check whether 'skiko-kjs' is loaded prior to 'coil-root-coil-core'.");
    }
    globalThis['coil-root-coil-core'] = factory(typeof globalThis['coil-root-coil-core'] === 'undefined' ? {} : globalThis['coil-root-coil-core'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-coroutines-core'], globalThis['kotlinx-atomicfu'], globalThis['okio-parent-okio'], globalThis['skiko-kjs']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_org_jetbrains_kotlinx_atomicfu, kotlin_com_squareup_okio_okio, kotlin_org_jetbrains_skiko_skiko) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var protoOf = kotlin_kotlin.$_$.eh;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var toMutableList = kotlin_kotlin.$_$.pc;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var listOf = kotlin_kotlin.$_$.sa;
  var to = kotlin_kotlin.$_$.ip;
  var emptyList = kotlin_kotlin.$_$.c9;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var addAll = kotlin_kotlin.$_$.o7;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var lazy = kotlin_kotlin.$_$.to;
  var KProperty1 = kotlin_kotlin.$_$.yi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var equals = kotlin_kotlin.$_$.sf;
  var hashCode = kotlin_kotlin.$_$.bg;
  var toString = kotlin_kotlin.$_$.hh;
  var Dispatchers_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h;
  var VOID = kotlin_kotlin.$_$.d;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var atomic$boolean$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.b;
  var SupervisorJob = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g3;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x2;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.b3;
  var Path = kotlin_com_squareup_okio_okio.$_$.g;
  var getKClass = kotlin_kotlin.$_$.si;
  var Bitmap = kotlin_org_jetbrains_skiko_skiko.$_$.s5;
  var AbstractCoroutineContextElement = kotlin_kotlin.$_$.md;
  var Key_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.f;
  var Element = kotlin_kotlin.$_$.vd;
  var sortedWith = kotlin_kotlin.$_$.yb;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var isInterface = kotlin_kotlin.$_$.rg;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var Comparator = kotlin_kotlin.$_$.bn;
  var compareValues = kotlin_kotlin.$_$.ad;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var Long = kotlin_kotlin.$_$.kn;
  var fromInt = kotlin_kotlin.$_$.pe;
  var multiply = kotlin_kotlin.$_$.ue;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.q2;
  var compare = kotlin_kotlin.$_$.je;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var toNumber = kotlin_kotlin.$_$.bf;
  var numberToLong = kotlin_kotlin.$_$.we;
  var coerceIn = kotlin_kotlin.$_$.fi;
  var Exception = kotlin_kotlin.$_$.gn;
  var buffer = kotlin_com_squareup_okio_okio.$_$.j;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x;
  var addSuppressed = kotlin_kotlin.$_$.eo;
  var subtract = kotlin_kotlin.$_$.af;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q3;
  var Regex_init_$Create$ = kotlin_kotlin.$_$.u4;
  var ForwardingFileSystem = kotlin_com_squareup_okio_okio.$_$.e;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var CoroutineScope_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var IOException = kotlin_com_squareup_okio_okio.$_$.f;
  var blackholeSink = kotlin_com_squareup_okio_okio.$_$.h;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var copyToArray = kotlin_kotlin.$_$.x8;
  var cancel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i3;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var AutoCloseable = kotlin_kotlin.$_$.wm;
  var Enum = kotlin_kotlin.$_$.en;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var stackTraceToString = kotlin_kotlin.$_$.yo;
  var Key_instance_0 = kotlin_kotlin.$_$.p2;
  var CoroutineDispatcher = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.v2;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.o6;
  var FileSystem = kotlin_com_squareup_okio_okio.$_$.d;
  var println = kotlin_kotlin.$_$.de;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.k4;
  var emptyMap = kotlin_kotlin.$_$.d9;
  var LinkedHashMap_init_$Create$_1 = kotlin_kotlin.$_$.l4;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.b4;
  var Entry = kotlin_kotlin.$_$.f7;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.m4;
  var KtMap = kotlin_kotlin.$_$.g7;
  var MutableEntry = kotlin_kotlin.$_$.j7;
  var KtMutableMap = kotlin_kotlin.$_$.k7;
  var KtList = kotlin_kotlin.$_$.e7;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(Builder, 'Builder', Builder_init_$Create$);
  initMetadataForClass(ComponentRegistry, 'ComponentRegistry', ComponentRegistry_init_$Create$);
  initMetadataForCompanion(Companion);
  initMetadataForClass(Key, 'Key');
  initMetadataForClass(Builder_0, 'Builder', Builder_init_$Create$_1);
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(Extras, 'Extras');
  initMetadataForClass(Builder_1, 'Builder');
  initMetadataForInterface(ImageLoader, 'ImageLoader', VOID, VOID, VOID, [1]);
  initMetadataForClass(Options, 'Options');
  initMetadataForClass(RealImageLoader, 'RealImageLoader', VOID, VOID, [ImageLoader], [1, 2]);
  initMetadataForClass(CoroutineScope$$inlined$CoroutineExceptionHandler$1, VOID, VOID, AbstractCoroutineContextElement, [Element]);
  initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(Uri, 'Uri');
  initMetadataForClass(Builder_2, 'Builder', Builder_2);
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(DiskLruCache$fileSystem$1, VOID, VOID, ForwardingFileSystem);
  initMetadataForLambda(DiskLruCache$launchCleanup$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(DiskLruCache, 'DiskLruCache', VOID, VOID, [AutoCloseable]);
  initMetadataForClass(FaultHidingSink, 'FaultHidingSink');
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(RealDiskCache, 'RealDiskCache');
  initMetadataForClass(Factory, 'Factory', Factory);
  initMetadataForClass(Factory_0, 'Factory', Factory_0);
  initMetadataForClass(Factory_1, 'Factory', Factory_1);
  initMetadataForClass(Factory_2, 'Factory', Factory_2);
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(EngineInterceptor, 'EngineInterceptor', VOID, VOID, VOID, [1, 4, 5, 6]);
  initMetadataForClass(FileUriKeyer, 'FileUriKeyer', FileUriKeyer);
  initMetadataForClass(UriKeyer, 'UriKeyer', UriKeyer);
  initMetadataForClass(PathMapper, 'PathMapper', PathMapper);
  initMetadataForClass(StringMapper, 'StringMapper', StringMapper);
  initMetadataForClass(Builder_3, 'Builder', Builder_3);
  initMetadataForCompanion(Companion_4);
  initMetadataForClass(MemoryCacheService, 'MemoryCacheService');
  initMetadataForClass(RealMemoryCache, 'RealMemoryCache');
  initMetadataForClass(LruCache, 'LruCache');
  initMetadataForClass(RealStrongMemoryCache$cache$1, VOID, VOID, LruCache);
  initMetadataForClass(RealStrongMemoryCache, 'RealStrongMemoryCache');
  initMetadataForClass(EmptyStrongMemoryCache, 'EmptyStrongMemoryCache');
  initMetadataForCompanion(Companion_5);
  initMetadataForClass(RealWeakMemoryCache, 'RealWeakMemoryCache', RealWeakMemoryCache);
  initMetadataForClass(EmptyWeakMemoryCache, 'EmptyWeakMemoryCache', EmptyWeakMemoryCache);
  initMetadataForClass(CachePolicy, 'CachePolicy', VOID, Enum);
  initMetadataForCompanion(Companion_6);
  initMetadataForClass(Defaults, 'Defaults', Defaults);
  initMetadataForClass(Pixels, 'Pixels');
  initMetadataForObject(Undefined, 'Undefined');
  initMetadataForClass(Precision, 'Precision', VOID, Enum);
  initMetadataForClass(RealSizeResolver, 'RealSizeResolver', VOID, VOID, VOID, [0]);
  initMetadataForClass(Scale, 'Scale', VOID, Enum);
  initMetadataForCompanion(Companion_7);
  initMetadataForClass(Size, 'Size');
  initMetadataForCompanion(Companion_8);
  function priority() {
    return 0;
  }
  initMetadataForInterface(FetcherServiceLoaderTarget, 'FetcherServiceLoaderTarget');
  function priority_0() {
    return 0;
  }
  initMetadataForInterface(DecoderServiceLoaderTarget, 'DecoderServiceLoaderTarget');
  initMetadataForClass(Level, 'Level', VOID, Enum);
  initMetadataForClass(DebugLogger, 'DebugLogger', DebugLogger);
  initMetadataForObject(ThrowingFileSystem, 'ThrowingFileSystem', VOID, FileSystem);
  initMetadataForInterface(Factory_3, 'Factory');
  initMetadataForClass(sam$coil3_EventListener_Factory$0, 'sam$coil3_EventListener_Factory$0', VOID, VOID, [Factory_3, FunctionAdapter]);
  initMetadataForCompanion(Companion_9);
  initMetadataForClass(EventListener, 'EventListener');
  initMetadataForClass(EventListener$Companion$NONE$1, VOID, VOID, EventListener);
  initMetadataForCompanion(Companion_10);
  initMetadataForClass(Factory_4, 'Factory', Factory_4);
  initMetadataForClass(NonAndroidRequestService, 'NonAndroidRequestService');
  initMetadataForClass(NoopSystemCallbacks, 'NoopSystemCallbacks', NoopSystemCallbacks);
  initMetadataForObject(ServiceLoaderComponentRegistry, 'ServiceLoaderComponentRegistry');
  initMetadataForClass(ImmutableEntry, 'ImmutableEntry', VOID, VOID, [Entry]);
  initMetadataForClass(ImmutableMap, 'ImmutableMap', VOID, VOID, [KtMap]);
  initMetadataForClass(MutableEntry_0, 'MutableEntry', VOID, VOID, [MutableEntry]);
  initMetadataForClass(LruMutableMap_0, 'LruMutableMap', VOID, VOID, [KtMutableMap]);
  initMetadataForClass(ImmutableIterator, 'ImmutableIterator');
  initMetadataForClass(ImmutableListIterator, 'ImmutableListIterator');
  initMetadataForClass(ImmutableList, 'ImmutableList', VOID, VOID, [KtList]);
  //endregion
  function Builder_init_$Init$($this) {
    Builder.call($this);
    var tmp = $this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.vxb_1 = ArrayList_init_$Create$();
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.wxb_1 = ArrayList_init_$Create$();
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_1.xxb_1 = ArrayList_init_$Create$();
    var tmp_2 = $this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_2.yxb_1 = ArrayList_init_$Create$();
    var tmp_3 = $this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_3.zxb_1 = ArrayList_init_$Create$();
    return $this;
  }
  function Builder_init_$Create$() {
    return Builder_init_$Init$(objectCreate(protoOf(Builder)));
  }
  function Builder_init_$Init$_0(registry, $this) {
    Builder.call($this);
    $this.vxb_1 = toMutableList(registry.axc_1);
    $this.wxb_1 = toMutableList(registry.bxc_1);
    $this.xxb_1 = toMutableList(registry.cxc_1);
    var tmp = $this;
    var tmp0 = registry.hxc();
    // Inline function 'kotlin.collections.mutableListOf' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var tmp$ret$2 = ComponentRegistry$Builder$_init_$lambda_dk7m6y(item);
      destination.j1(tmp$ret$2);
    }
    tmp.yxb_1 = destination;
    var tmp_0 = $this;
    var tmp0_0 = registry.ixc();
    // Inline function 'kotlin.collections.mutableListOf' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = tmp0_0.t();
    while (_iterator__ex2g4s_0.u()) {
      var item_0 = _iterator__ex2g4s_0.v();
      var tmp$ret$5 = ComponentRegistry$Builder$_init_$lambda_dk7m6y_0(item_0);
      destination_0.j1(tmp$ret$5);
    }
    tmp_0.zxb_1 = destination_0;
    return $this;
  }
  function Builder_init_$Create$_0(registry) {
    return Builder_init_$Init$_0(registry, objectCreate(protoOf(Builder)));
  }
  function ComponentRegistry$Builder$_init_$lambda_dk7m6y($it) {
    return function () {
      return listOf($it);
    };
  }
  function ComponentRegistry$Builder$_init_$lambda_dk7m6y_0($it) {
    return function () {
      return listOf($it);
    };
  }
  function ComponentRegistry$Builder$add$lambda($factory, $type) {
    return function () {
      return listOf(to($factory, $type));
    };
  }
  function ComponentRegistry$Builder$add$lambda_0($factory) {
    return function () {
      return listOf($factory);
    };
  }
  function ComponentRegistry_init_$Init$($this) {
    ComponentRegistry.call($this, emptyList(), emptyList(), emptyList(), emptyList(), emptyList());
    return $this;
  }
  function ComponentRegistry_init_$Create$() {
    return ComponentRegistry_init_$Init$(objectCreate(protoOf(ComponentRegistry)));
  }
  protoOf(Builder).jxc = function (interceptor) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.vxb_1.j1(interceptor);
    return this;
  };
  protoOf(Builder).kxc = function (mapper, type) {
    // Inline function 'kotlin.apply' call
    var tmp0 = this.wxb_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = to(mapper, type);
    tmp0.j1(element);
    return this;
  };
  protoOf(Builder).lxc = function (keyer, type) {
    // Inline function 'kotlin.apply' call
    var tmp0 = this.xxb_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = to(keyer, type);
    tmp0.j1(element);
    return this;
  };
  protoOf(Builder).mxc = function (factory, type) {
    // Inline function 'kotlin.apply' call
    var tmp0 = this.yxb_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = ComponentRegistry$Builder$add$lambda(factory, type);
    tmp0.j1(element);
    return this;
  };
  protoOf(Builder).nxc = function (factory) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.yxb_1.j1(factory);
    return this;
  };
  protoOf(Builder).oxc = function (factory) {
    // Inline function 'kotlin.apply' call
    var tmp0 = this.zxb_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = ComponentRegistry$Builder$add$lambda_0(factory);
    tmp0.j1(element);
    return this;
  };
  protoOf(Builder).pxc = function (factory) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.zxb_1.j1(factory);
    return this;
  };
  protoOf(Builder).g3d = function () {
    return new ComponentRegistry(toImmutableList(this.vxb_1), toImmutableList(this.wxb_1), toImmutableList(this.xxb_1), toImmutableList(this.yxb_1), toImmutableList(this.zxb_1));
  };
  function Builder() {
  }
  function ComponentRegistry$fetcherFactories$delegate$lambda(this$0) {
    return function () {
      // Inline function 'coil3.util.flatMapIndices' call
      var this_0 = this$0.dxc_1;
      // Inline function 'kotlin.collections.mutableListOf' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.collections.plusAssign' call
          var elements = this_0.l1(i)();
          addAll(destination, elements);
        }
         while (inductionVariable <= last);
      // Inline function 'kotlin.also' call
      this$0.dxc_1 = emptyList();
      return destination;
    };
  }
  function ComponentRegistry$_get_fetcherFactories_$ref_gzdmrh() {
    return constructCallableReference(function (p0) {
      return p0.hxc();
    }, 1, 0, 521);
  }
  function ComponentRegistry$decoderFactories$delegate$lambda(this$0) {
    return function () {
      // Inline function 'coil3.util.flatMapIndices' call
      var this_0 = this$0.exc_1;
      // Inline function 'kotlin.collections.mutableListOf' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.collections.plusAssign' call
          var elements = this_0.l1(i)();
          addAll(destination, elements);
        }
         while (inductionVariable <= last);
      // Inline function 'kotlin.also' call
      this$0.exc_1 = emptyList();
      return destination;
    };
  }
  function ComponentRegistry$_get_decoderFactories_$ref_2x7bhc() {
    return constructCallableReference(function (p0) {
      return p0.ixc();
    }, 1, 0, 522);
  }
  function ComponentRegistry(interceptors, mappers, keyers, lazyFetcherFactories, lazyDecoderFactories) {
    this.axc_1 = interceptors;
    this.bxc_1 = mappers;
    this.cxc_1 = keyers;
    this.dxc_1 = lazyFetcherFactories;
    this.exc_1 = lazyDecoderFactories;
    var tmp = this;
    tmp.fxc_1 = lazy(ComponentRegistry$fetcherFactories$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.gxc_1 = lazy(ComponentRegistry$decoderFactories$delegate$lambda(this));
  }
  protoOf(ComponentRegistry).hxc = function () {
    var tmp0 = this.fxc_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('fetcherFactories', 1, tmp, ComponentRegistry$_get_fetcherFactories_$ref_gzdmrh(), null);
    return tmp0.u1();
  };
  protoOf(ComponentRegistry).ixc = function () {
    var tmp0 = this.gxc_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('decoderFactories', 1, tmp, ComponentRegistry$_get_decoderFactories_$ref_2x7bhc(), null);
    return tmp0.u1();
  };
  protoOf(ComponentRegistry).qxc = function () {
    return Builder_init_$Create$_0(this);
  };
  function Companion() {
  }
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function Builder_init_$Init$_1($this) {
    Builder_0.call($this);
    var tmp = $this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.rxc_1 = LinkedHashMap_init_$Create$();
    return $this;
  }
  function Builder_init_$Create$_1() {
    return Builder_init_$Init$_1(objectCreate(protoOf(Builder_0)));
  }
  function Key(default_0) {
    this.sxc_1 = default_0;
  }
  protoOf(Builder_0).txc = function (key, value) {
    // Inline function 'kotlin.apply' call
    if (!(value == null)) {
      // Inline function 'kotlin.collections.set' call
      this.rxc_1.z2(key, value);
    } else {
      // Inline function 'kotlin.collections.minusAssign' call
      this.rxc_1.a3(key);
    }
    return this;
  };
  protoOf(Builder_0).g3d = function () {
    return new Extras(toImmutableMap(this.rxc_1));
  };
  function Builder_0() {
  }
  function Companion_0() {
    Companion_instance_0 = this;
    this.uxc_1 = Builder_init_$Create$_1().g3d();
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function Extras(data) {
    Companion_getInstance_0();
    this.vxc_1 = data;
  }
  protoOf(Extras).wxc = function (key) {
    return this.vxc_1.w2(key);
  };
  protoOf(Extras).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Extras))
      return false;
    if (!equals(this.vxc_1, other.vxc_1))
      return false;
    return true;
  };
  protoOf(Extras).hashCode = function () {
    return hashCode(this.vxc_1);
  };
  protoOf(Extras).toString = function () {
    return 'Extras(data=' + toString(this.vxc_1) + ')';
  };
  function getOrDefault(_this__u8e3s4, key) {
    var tmp0_elvis_lhs = _this__u8e3s4.wxc(key);
    return tmp0_elvis_lhs == null ? key.sxc_1 : tmp0_elvis_lhs;
  }
  function Builder_init_$Init$_2(context, $this) {
    Builder_1.call($this);
    $this.xxc_1 = get_application(context);
    $this.yxc_1 = Companion_getInstance_6().gxd_1;
    $this.zxc_1 = null;
    $this.axd_1 = null;
    $this.bxd_1 = null;
    $this.cxd_1 = null;
    $this.dxd_1 = null;
    $this.exd_1 = null;
    $this.fxd_1 = Builder_init_$Create$_1();
    return $this;
  }
  function Builder_init_$Create$_2(context) {
    return Builder_init_$Init$_2(context, objectCreate(protoOf(Builder_1)));
  }
  function ImageLoader$Builder$build$lambda() {
    return Dispatchers_getInstance().m1h().o1l();
  }
  function ImageLoader$Builder$build$lambda_0(this$0) {
    return function () {
      return (new Builder_3()).kxd(this$0.xxc_1).g3d();
    };
  }
  function ImageLoader$Builder$build$lambda_1() {
    return singletonDiskCache();
  }
  protoOf(Builder_1).lxd = function (components) {
    // Inline function 'kotlin.apply' call
    this.dxd_1 = components;
    return this;
  };
  protoOf(Builder_1).mxd = function (initializer) {
    // Inline function 'kotlin.apply' call
    this.axd_1 = lazy(initializer);
    return this;
  };
  protoOf(Builder_1).nxd = function (initializer) {
    // Inline function 'kotlin.apply' call
    this.bxd_1 = lazy(initializer);
    return this;
  };
  protoOf(Builder_1).oxd = function (policy) {
    // Inline function 'kotlin.apply' call
    this.yxc_1 = this.yxc_1.dxe(VOID, VOID, VOID, VOID, policy);
    return this;
  };
  protoOf(Builder_1).exe = function (policy) {
    // Inline function 'kotlin.apply' call
    this.yxc_1 = this.yxc_1.dxe(VOID, VOID, VOID, VOID, VOID, policy);
    return this;
  };
  protoOf(Builder_1).fxe = function (policy) {
    // Inline function 'kotlin.apply' call
    this.yxc_1 = this.yxc_1.dxe(VOID, VOID, VOID, VOID, VOID, VOID, policy);
    return this;
  };
  protoOf(Builder_1).gxe = function (logger) {
    // Inline function 'kotlin.apply' call
    this.exd_1 = logger;
    return this;
  };
  protoOf(Builder_1).g3d = function () {
    var tmp = this.yxc_1.dxe(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.fxd_1.g3d());
    var tmp0_elvis_lhs = this.zxc_1;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      tmp_0 = lazy(ImageLoader$Builder$build$lambda);
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var tmp_1 = tmp_0;
    var tmp1_elvis_lhs = this.axd_1;
    var tmp_2;
    if (tmp1_elvis_lhs == null) {
      tmp_2 = lazy(ImageLoader$Builder$build$lambda_0(this));
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    var tmp_3 = tmp_2;
    var tmp2_elvis_lhs = this.bxd_1;
    var tmp_4;
    if (tmp2_elvis_lhs == null) {
      tmp_4 = lazy(ImageLoader$Builder$build$lambda_1);
    } else {
      tmp_4 = tmp2_elvis_lhs;
    }
    var tmp_5 = tmp_4;
    var tmp3_elvis_lhs = this.cxd_1;
    var tmp_6 = tmp3_elvis_lhs == null ? Companion_getInstance_9().hxe_1 : tmp3_elvis_lhs;
    var tmp4_elvis_lhs = this.dxd_1;
    var options = new Options(this.xxc_1, tmp, tmp_1, tmp_3, tmp_5, tmp_6, tmp4_elvis_lhs == null ? ComponentRegistry_init_$Create$() : tmp4_elvis_lhs, this.exd_1);
    return new RealImageLoader(options);
  };
  function Builder_1() {
  }
  function ImageLoader() {
  }
  function Options(application, defaults, mainCoroutineContextLazy, memoryCacheLazy, diskCacheLazy, eventListenerFactory, componentRegistry, logger) {
    this.jxe_1 = application;
    this.kxe_1 = defaults;
    this.lxe_1 = mainCoroutineContextLazy;
    this.mxe_1 = memoryCacheLazy;
    this.nxe_1 = diskCacheLazy;
    this.oxe_1 = eventListenerFactory;
    this.pxe_1 = componentRegistry;
    this.qxe_1 = logger;
  }
  protoOf(Options).toString = function () {
    return 'Options(application=' + toString(this.jxe_1) + ', defaults=' + this.kxe_1.toString() + ', mainCoroutineContextLazy=' + toString(this.lxe_1) + ', memoryCacheLazy=' + toString(this.mxe_1) + ', diskCacheLazy=' + toString(this.nxe_1) + ', eventListenerFactory=' + toString(this.oxe_1) + ', componentRegistry=' + toString(this.pxe_1) + ', logger=' + toString_0(this.qxe_1) + ')';
  };
  protoOf(Options).hashCode = function () {
    var result = hashCode(this.jxe_1);
    result = imul(result, 31) + this.kxe_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.lxe_1) | 0;
    result = imul(result, 31) + hashCode(this.mxe_1) | 0;
    result = imul(result, 31) + hashCode(this.nxe_1) | 0;
    result = imul(result, 31) + hashCode(this.oxe_1) | 0;
    result = imul(result, 31) + hashCode(this.pxe_1) | 0;
    result = imul(result, 31) + (this.qxe_1 == null ? 0 : hashCode(this.qxe_1)) | 0;
    return result;
  };
  protoOf(Options).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Options))
      return false;
    if (!equals(this.jxe_1, other.jxe_1))
      return false;
    if (!this.kxe_1.equals(other.kxe_1))
      return false;
    if (!equals(this.lxe_1, other.lxe_1))
      return false;
    if (!equals(this.mxe_1, other.mxe_1))
      return false;
    if (!equals(this.nxe_1, other.nxe_1))
      return false;
    if (!equals(this.oxe_1, other.oxe_1))
      return false;
    if (!equals(this.pxe_1, other.pxe_1))
      return false;
    if (!equals(this.qxe_1, other.qxe_1))
      return false;
    return true;
  };
  function RealImageLoader(options) {
    this.rxe_1 = options;
    this.sxe_1 = CoroutineScope_1(this.rxe_1.qxe_1);
    this.txe_1 = SystemCallbacks(this);
    this.uxe_1 = RequestService(this, this.txe_1, this.rxe_1.qxe_1);
    this.vxe_1 = this.rxe_1.mxe_1;
    this.wxe_1 = this.rxe_1.nxe_1;
    this.xxe_1 = addCommonComponents(addAppleComponents(addJvmComponents(addAndroidComponents(addServiceLoaderComponents(this.rxe_1.pxe_1.qxc(), this.rxe_1), this.rxe_1), this.rxe_1), this.rxe_1)).jxc(new EngineInterceptor(this, this.txe_1, this.uxe_1, this.rxe_1.qxe_1)).g3d();
    this.yxe_1 = atomic$boolean$1(false);
  }
  protoOf(RealImageLoader).ixe = function () {
    return this.rxe_1.kxe_1;
  };
  function CoroutineScope_1(logger) {
    var tmp = SupervisorJob();
    // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
    var tmp$ret$0 = new CoroutineScope$$inlined$CoroutineExceptionHandler$1(logger);
    var context = tmp.xj(tmp$ret$0);
    return CoroutineScope(context);
  }
  function addCommonComponents(_this__u8e3s4) {
    // Inline function 'coil3.Builder.add' call
    var mapper = new StringMapper();
    var tmp0 = _this__u8e3s4.kxc(mapper, PrimitiveClasses_getInstance().rc());
    // Inline function 'coil3.Builder.add' call
    var mapper_0 = new PathMapper();
    var tmp0_0 = tmp0.kxc(mapper_0, getKClass(Path));
    // Inline function 'coil3.Builder.add' call
    var keyer = new FileUriKeyer();
    var tmp0_1 = tmp0_0.lxc(keyer, getKClass(Uri));
    // Inline function 'coil3.Builder.add' call
    var keyer_0 = new UriKeyer();
    var tmp0_2 = tmp0_1.lxc(keyer_0, getKClass(Uri));
    // Inline function 'coil3.Builder.add' call
    var factory = new Factory_2();
    var tmp0_3 = tmp0_2.mxc(factory, getKClass(Uri));
    // Inline function 'coil3.Builder.add' call
    var factory_0 = new Factory_0();
    var tmp0_4 = tmp0_3.mxc(factory_0, PrimitiveClasses_getInstance().vc());
    // Inline function 'coil3.Builder.add' call
    var factory_1 = new Factory_1();
    var tmp0_5 = tmp0_4.mxc(factory_1, getKClass(Uri));
    // Inline function 'coil3.Builder.add' call
    var factory_2 = new Factory();
    return tmp0_5.mxc(factory_2, getKClass(Bitmap));
  }
  function addServiceLoaderComponents(_this__u8e3s4, options) {
    if (get_serviceLoaderEnabled(options)) {
      _this__u8e3s4.nxc(addServiceLoaderComponents$lambda);
      _this__u8e3s4.pxc(addServiceLoaderComponents$lambda_0);
    }
    return _this__u8e3s4;
  }
  function CoroutineScope$$inlined$CoroutineExceptionHandler$1($logger) {
    this.axf_1 = $logger;
    AbstractCoroutineContextElement.call(this, Key_instance);
  }
  protoOf(CoroutineScope$$inlined$CoroutineExceptionHandler$1).f1h = function (context, exception) {
    var tmp0_safe_receiver = this.axf_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      log(tmp0_safe_receiver, 'RealImageLoader', exception);
    }
    return Unit_instance;
  };
  function addServiceLoaderComponents$lambda() {
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_0 = ServiceLoaderComponentRegistry_getInstance().exf();
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = addServiceLoaderComponents$lambda$lambda;
    var tmp$ret$1 = new sam$kotlin_Comparator$0(tmp);
    // Inline function 'coil3.util.mapNotNullIndices' call
    var this_1 = sortedWith(this_0, tmp$ret$1);
    // Inline function 'kotlin.collections.mutableListOf' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_1.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0 = this_1.l1(i);
        var tmp$ret$4;
        $l$block_0: {
          if (!isInterface(tmp0, FetcherServiceLoaderTarget))
            THROW_CCE();
          var tmp0_elvis_lhs = tmp0.fxf();
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            tmp$ret$4 = null;
            break $l$block_0;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var factory = tmp_0;
          var tmp1_elvis_lhs = tmp0.gxf();
          var tmp_1;
          if (tmp1_elvis_lhs == null) {
            tmp$ret$4 = null;
            break $l$block_0;
          } else {
            tmp_1 = tmp1_elvis_lhs;
          }
          var type = tmp_1;
          tmp$ret$4 = to(factory, type);
        }
        var value = tmp$ret$4;
        if (!(value == null)) {
          // Inline function 'kotlin.collections.plusAssign' call
          destination.j1(value);
        }
      }
       while (inductionVariable <= last);
    return destination;
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.hxf_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).ze = function (a, b) {
    return this.hxf_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).q3 = function () {
    return this.hxf_1;
  };
  protoOf(sam$kotlin_Comparator$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function addServiceLoaderComponents$lambda$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = b.ixf();
    var tmp$ret$2 = a.ixf();
    return compareValues(tmp, tmp$ret$2);
  }
  function addServiceLoaderComponents$lambda_0() {
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_0 = ServiceLoaderComponentRegistry_getInstance().jxf();
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = addServiceLoaderComponents$lambda$lambda_0;
    var tmp$ret$1 = new sam$kotlin_Comparator$0(tmp);
    // Inline function 'coil3.util.mapNotNullIndices' call
    var this_1 = sortedWith(this_0, tmp$ret$1);
    // Inline function 'kotlin.collections.mutableListOf' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_1.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var value = this_1.l1(i).fxf();
        if (!(value == null)) {
          // Inline function 'kotlin.collections.plusAssign' call
          destination.j1(value);
        }
      }
       while (inductionVariable <= last);
    return destination;
  }
  function addServiceLoaderComponents$lambda$lambda_0(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = b.ixf();
    var tmp$ret$2 = a.ixf();
    return compareValues(tmp, tmp$ret$2);
  }
  function Uri(data, separator, scheme, authority, path, query, fragment) {
    this.kxf_1 = data;
    this.lxf_1 = separator;
    this.mxf_1 = scheme;
    this.nxf_1 = authority;
    this.oxf_1 = path;
    this.pxf_1 = query;
    this.qxf_1 = fragment;
  }
  protoOf(Uri).equals = function (other) {
    if (this === other)
      return true;
    var tmp;
    if (other instanceof Uri) {
      tmp = other.kxf_1 === this.kxf_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Uri).hashCode = function () {
    return getStringHashCode(this.kxf_1);
  };
  protoOf(Uri).toString = function () {
    return this.kxf_1;
  };
  function Builder_2() {
    this.rxf_1 = null;
    this.sxf_1 = defaultFileSystem();
    this.txf_1 = 0.02;
    var tmp = this;
    // Inline function 'kotlin.Long.times' call
    var this_0 = new Long(10, 0);
    // Inline function 'kotlin.Long.times' call
    var this_1 = multiply(this_0, fromInt(1024));
    tmp.uxf_1 = multiply(this_1, fromInt(1024));
    var tmp_0 = this;
    // Inline function 'kotlin.Long.times' call
    var this_2 = new Long(250, 0);
    // Inline function 'kotlin.Long.times' call
    var this_3 = multiply(this_2, fromInt(1024));
    tmp_0.vxf_1 = multiply(this_3, fromInt(1024));
    this.wxf_1 = new Long(0, 0);
    this.xxf_1 = EmptyCoroutineContext_getInstance();
  }
  protoOf(Builder_2).yxf = function (directory) {
    // Inline function 'kotlin.apply' call
    this.rxf_1 = directory;
    return this;
  };
  protoOf(Builder_2).zxf = function (size) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.require' call
    if (!(compare(size, new Long(0, 0)) > 0)) {
      var message = 'size must be > 0.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    this.txf_1 = 0.0;
    this.wxf_1 = size;
    return this;
  };
  protoOf(Builder_2).g3d = function () {
    var tmp0 = this.rxf_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'directory == null';
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        tmp$ret$0 = tmp0;
        break $l$block;
      }
    }
    var directory = tmp$ret$0;
    var tmp;
    if (this.txf_1 > 0) {
      var tmp_0;
      try {
        var size = this.txf_1 * toNumber(remainingFreeSpaceBytes(this.sxf_1, directory));
        tmp_0 = coerceIn(numberToLong(size), this.uxf_1, this.vxf_1);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Exception) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = this.uxf_1;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      tmp = this.wxf_1;
    }
    var maxSize = tmp;
    return new RealDiskCache(maxSize, directory, this.sxf_1, this.xxf_1);
  };
  function newJournalWriter($this) {
    var fileSink = $this.sxg_1.hvp($this.exg_1);
    var faultHidingSink = new FaultHidingSink(fileSink, DiskLruCache$newJournalWriter$lambda($this));
    return buffer(faultHidingSink);
  }
  function writeJournal($this) {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    $this.jxg_1;
    var tmp0_safe_receiver = $this.mxg_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.j4();
    }
    var tmp0 = $this.sxg_1;
    // Inline function 'okio.FileSystem.write' call
    var file = $this.fxg_1;
    // Inline function 'okio.use' call
    var this_0 = buffer(tmp0.fvp(file, false));
    var thrown = null;
    var tmp;
    try {
      var tmp_0 = this_0.uvq('libcore.io.DiskLruCache');
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(10);
      var tmp$ret$6 = Char__toInt_impl_vasixd(this_1);
      tmp_0.ivt(tmp$ret$6);
      var tmp_1 = this_0.uvq('1');
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(10);
      var tmp$ret$7 = Char__toInt_impl_vasixd(this_2);
      tmp_1.ivt(tmp$ret$7);
      var tmp_2 = this_0.lvt(fromInt($this.cxg_1));
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(10);
      var tmp$ret$8 = Char__toInt_impl_vasixd(this_3);
      tmp_2.ivt(tmp$ret$8);
      var tmp_3 = this_0.lvt(fromInt($this.dxg_1));
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(10);
      var tmp$ret$9 = Char__toInt_impl_vasixd(this_4);
      tmp_3.ivt(tmp$ret$9);
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(10);
      var tmp$ret$10 = Char__toInt_impl_vasixd(this_5);
      this_0.ivt(tmp$ret$10);
      var _iterator__ex2g4s = $this.hxg_1.y2().t();
      while (_iterator__ex2g4s.u()) {
        var entry = _iterator__ex2g4s.v();
        if (!(entry.zxg_1 == null)) {
          this_0.uvq('DIRTY');
          // Inline function 'kotlin.code' call
          var this_6 = _Char___init__impl__6a9atx(32);
          var tmp$ret$11 = Char__toInt_impl_vasixd(this_6);
          this_0.ivt(tmp$ret$11);
          this_0.uvq(entry.txg_1);
          // Inline function 'kotlin.code' call
          var this_7 = _Char___init__impl__6a9atx(10);
          var tmp$ret$12 = Char__toInt_impl_vasixd(this_7);
          this_0.ivt(tmp$ret$12);
        } else {
          this_0.uvq('CLEAN');
          // Inline function 'kotlin.code' call
          var this_8 = _Char___init__impl__6a9atx(32);
          var tmp$ret$13 = Char__toInt_impl_vasixd(this_8);
          this_0.ivt(tmp$ret$13);
          this_0.uvq(entry.txg_1);
          entry.cxh(this_0);
          // Inline function 'kotlin.code' call
          var this_9 = _Char___init__impl__6a9atx(10);
          var tmp$ret$14 = Char__toInt_impl_vasixd(this_9);
          this_0.ivt(tmp$ret$14);
        }
      }
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_4;
      if ($p instanceof Error) {
        var t = $p;
        thrown = t;
        tmp_4 = null;
      } else {
        throw $p;
      }
      tmp = tmp_4;
    }
    finally {
      try {
        if (this_0 == null)
          null;
        else {
          this_0.j4();
        }
      } catch ($p_0) {
        if ($p_0 instanceof Error) {
          var t_0 = $p_0;
          if (thrown == null) {
            thrown = t_0;
          } else {
            addSuppressed(thrown, t_0);
          }
        } else {
          throw $p_0;
        }
      }
    }
    var result = tmp;
    if (!(thrown == null))
      throw thrown;
    if ($this.sxg_1.nvp($this.exg_1)) {
      $this.sxg_1.kvp($this.exg_1, $this.gxg_1);
      $this.sxg_1.kvp($this.fxg_1, $this.exg_1);
      $this.sxg_1.mvp($this.gxg_1);
    } else {
      $this.sxg_1.kvp($this.fxg_1, $this.exg_1);
    }
    $this.mxg_1 = newJournalWriter($this);
    $this.lxg_1 = 0;
    $this.nxg_1 = false;
    $this.rxg_1 = false;
    return Unit_instance;
  }
  function journalRewriteRequired($this) {
    return $this.lxg_1 >= 2000;
  }
  function removeEntry($this, entry) {
    if (entry.axh_1 > 0) {
      var tmp0_safe_receiver = $this.mxg_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.apply' call
        tmp0_safe_receiver.uvq('DIRTY');
        // Inline function 'kotlin.code' call
        var this_0 = _Char___init__impl__6a9atx(32);
        var tmp$ret$2 = Char__toInt_impl_vasixd(this_0);
        tmp0_safe_receiver.ivt(tmp$ret$2);
        tmp0_safe_receiver.uvq(entry.txg_1);
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(10);
        var tmp$ret$3 = Char__toInt_impl_vasixd(this_1);
        tmp0_safe_receiver.ivt(tmp$ret$3);
        tmp0_safe_receiver.k9();
      }
    }
    if (entry.axh_1 > 0 || !(entry.zxg_1 == null)) {
      entry.yxg_1 = true;
      return Unit_instance;
    }
    var inductionVariable = 0;
    var last = $this.dxg_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        $this.sxg_1.mvp(entry.vxg_1.l1(i));
        $this.kxg_1 = subtract($this.kxg_1, entry.uxg_1[i]);
        entry.uxg_1[i] = new Long(0, 0);
      }
       while (inductionVariable < last);
    $this.lxg_1 = $this.lxg_1 + 1 | 0;
    var tmp1_safe_receiver = $this.mxg_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.apply' call
      tmp1_safe_receiver.uvq('REMOVE');
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(32);
      var tmp$ret$6 = Char__toInt_impl_vasixd(this_2);
      tmp1_safe_receiver.ivt(tmp$ret$6);
      tmp1_safe_receiver.uvq(entry.txg_1);
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(10);
      var tmp$ret$7 = Char__toInt_impl_vasixd(this_3);
      tmp1_safe_receiver.ivt(tmp$ret$7);
      tmp1_safe_receiver.k9();
    }
    $this.hxg_1.a3(entry.txg_1);
    if (journalRewriteRequired($this)) {
      launchCleanup($this);
    }
  }
  function trimToSize($this) {
    while (compare($this.kxg_1, $this.bxg_1) > 0) {
      if (!removeOldestEntry($this))
        return Unit_instance;
    }
    $this.qxg_1 = false;
  }
  function removeOldestEntry($this) {
    var _iterator__ex2g4s = $this.hxg_1.y2().t();
    while (_iterator__ex2g4s.u()) {
      var toEvict = _iterator__ex2g4s.v();
      if (!toEvict.yxg_1) {
        removeEntry($this, toEvict);
        return true;
      }
    }
    return false;
  }
  function launchCleanup($this) {
    launch($this.ixg_1, VOID, VOID, DiskLruCache$launchCleanup$slambda_0($this, null));
  }
  function Companion_1() {
    Companion_instance_1 = this;
    this.dxh_1 = 'journal';
    this.exh_1 = 'journal.tmp';
    this.fxh_1 = 'journal.bkp';
    this.gxh_1 = 'libcore.io.DiskLruCache';
    this.hxh_1 = '1';
    this.ixh_1 = 'CLEAN';
    this.jxh_1 = 'DIRTY';
    this.kxh_1 = 'REMOVE';
    this.lxh_1 = 'READ';
    var tmp = this;
    // Inline function 'kotlin.text.toRegex' call
    var this_0 = '[a-z0-9_-]{1,120}';
    tmp.mxh_1 = Regex_init_$Create$(this_0);
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function DiskLruCache$fileSystem$1($fileSystem) {
    ForwardingFileSystem.call(this, $fileSystem);
  }
  protoOf(DiskLruCache$fileSystem$1).fvp = function (file, mustCreate) {
    var tmp0_safe_receiver = file.k1a();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.pvp(tmp0_safe_receiver);
    }
    return protoOf(ForwardingFileSystem).fvp.call(this, file, mustCreate);
  };
  function DiskLruCache$newJournalWriter$lambda(this$0) {
    return function (it) {
      this$0.nxg_1 = true;
      return Unit_instance;
    };
  }
  function DiskLruCache$launchCleanup$slambda(this$0, resultContinuation) {
    this.wxh_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DiskLruCache$launchCleanup$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DiskLruCache$launchCleanup$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DiskLruCache$launchCleanup$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.wxh_1.jxg_1;
          if (!this.wxh_1.oxg_1 || this.wxh_1.pxg_1)
            return Unit_instance;
          try {
            trimToSize(this.wxh_1);
          } catch ($p) {
            if ($p instanceof IOException) {
              var _unused_var__etf5q3 = $p;
              this.wxh_1.qxg_1 = true;
            } else {
              throw $p;
            }
          }
          try {
            if (journalRewriteRequired(this.wxh_1)) {
              writeJournal(this.wxh_1);
            }
          } catch ($p_0) {
            if ($p_0 instanceof IOException) {
              var _unused_var__etf5q3_0 = $p_0;
              this.wxh_1.rxg_1 = true;
              this.wxh_1.mxg_1 = buffer(blackholeSink());
            } else {
              throw $p_0;
            }
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p_1) {
        var e = $p_1;
        throw e;
      }
     while (true);
  };
  protoOf(DiskLruCache$launchCleanup$slambda).q24 = function ($this$launch, completion) {
    var i = new DiskLruCache$launchCleanup$slambda(this.wxh_1, completion);
    i.xxh_1 = $this$launch;
    return i;
  };
  function DiskLruCache$launchCleanup$slambda_0(this$0, resultContinuation) {
    var i = new DiskLruCache$launchCleanup$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function DiskLruCache(fileSystem, directory, cleanupCoroutineContext, maxSize, appVersion, valueCount) {
    Companion_getInstance_1();
    this.axg_1 = directory;
    this.bxg_1 = maxSize;
    this.cxg_1 = appVersion;
    this.dxg_1 = valueCount;
    // Inline function 'kotlin.require' call
    if (!(compare(this.bxg_1, new Long(0, 0)) > 0)) {
      var message = 'maxSize <= 0';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!(this.dxg_1 > 0)) {
      var message_0 = 'valueCount <= 0';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    this.exg_1 = this.axg_1.pvt('journal');
    this.fxg_1 = this.axg_1.pvt('journal.tmp');
    this.gxg_1 = this.axg_1.pvt('journal.bkp');
    this.hxg_1 = LruMutableMap();
    var tmp = this;
    var tmp_0 = cleanupCoroutineContext.xj(SupervisorJob());
    var tmp0_elvis_lhs = get_dispatcher(cleanupCoroutineContext);
    tmp.ixg_1 = CoroutineScope(tmp_0.xj((tmp0_elvis_lhs == null ? ioCoroutineDispatcher() : tmp0_elvis_lhs).a1h(1)));
    this.jxg_1 = new Object();
    this.kxg_1 = new Long(0, 0);
    this.lxg_1 = 0;
    this.mxg_1 = null;
    this.nxg_1 = false;
    this.oxg_1 = false;
    this.pxg_1 = false;
    this.qxg_1 = false;
    this.rxg_1 = false;
    var tmp_1 = this;
    tmp_1.sxg_1 = new DiskLruCache$fileSystem$1(fileSystem);
  }
  protoOf(DiskLruCache).j4 = function () {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.jxg_1;
    if (!this.oxg_1 || this.pxg_1) {
      this.pxg_1 = true;
      return Unit_instance;
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.hxg_1.y2();
    var indexedObject = copyToArray(this_0);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var entry = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0_safe_receiver = entry.zxg_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.cxi();
      }
    }
    trimToSize(this);
    cancel(this.ixg_1);
    ensureNotNull(this.mxg_1).j4();
    this.mxg_1 = null;
    this.pxg_1 = true;
    return Unit_instance;
  };
  function FaultHidingSink(delegate, onException) {
    this.dxi_1 = delegate;
    this.exi_1 = onException;
    this.fxi_1 = false;
  }
  protoOf(FaultHidingSink).qvp = function (source, byteCount) {
    if (this.fxi_1) {
      source.is8(byteCount);
      return Unit_instance;
    }
    try {
      this.dxi_1.qvp(source, byteCount);
    } catch ($p) {
      if ($p instanceof IOException) {
        var e = $p;
        this.fxi_1 = true;
        this.exi_1(e);
      } else {
        throw $p;
      }
    }
  };
  protoOf(FaultHidingSink).k9 = function () {
    try {
      this.dxi_1.k9();
    } catch ($p) {
      if ($p instanceof IOException) {
        var e = $p;
        this.fxi_1 = true;
        this.exi_1(e);
      } else {
        throw $p;
      }
    }
  };
  protoOf(FaultHidingSink).j4 = function () {
    try {
      this.dxi_1.j4();
    } catch ($p) {
      if ($p instanceof IOException) {
        var e = $p;
        this.fxi_1 = true;
        this.exi_1(e);
      } else {
        throw $p;
      }
    }
  };
  function Companion_2() {
    this.gxi_1 = 0;
    this.hxi_1 = 1;
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function RealDiskCache(maxSize, directory, fileSystem, cleanupCoroutineContext) {
    this.ixi_1 = maxSize;
    this.jxi_1 = directory;
    this.kxi_1 = fileSystem;
    this.lxi_1 = new DiskLruCache(this.kxi_1, this.jxi_1, cleanupCoroutineContext, this.ixi_1, 3, 2);
  }
  function Factory() {
  }
  function Factory_0() {
  }
  function Factory_1() {
  }
  function Factory_2() {
  }
  function get_serviceLoaderEnabledKey() {
    _init_properties_imageLoaders_kt__fgbxt1();
    return serviceLoaderEnabledKey;
  }
  var serviceLoaderEnabledKey;
  function get_serviceLoaderEnabled(_this__u8e3s4) {
    _init_properties_imageLoaders_kt__fgbxt1();
    return getOrDefault(_this__u8e3s4.kxe_1.cxe_1, get_serviceLoaderEnabledKey());
  }
  var properties_initialized_imageLoaders_kt_u99cbr;
  function _init_properties_imageLoaders_kt__fgbxt1() {
    if (!properties_initialized_imageLoaders_kt_u99cbr) {
      properties_initialized_imageLoaders_kt_u99cbr = true;
      serviceLoaderEnabledKey = new Key(true);
    }
  }
  function Companion_3() {
    this.mxi_1 = 'EngineInterceptor';
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    return Companion_instance_3;
  }
  function EngineInterceptor(imageLoader, systemCallbacks, requestService, logger) {
    this.nxi_1 = imageLoader;
    this.oxi_1 = systemCallbacks;
    this.pxi_1 = requestService;
    this.qxi_1 = logger;
    this.rxi_1 = new MemoryCacheService(this.nxi_1, this.pxi_1, this.qxi_1);
  }
  function FileUriKeyer() {
  }
  function UriKeyer() {
  }
  function PathMapper() {
  }
  function StringMapper() {
  }
  function MemoryCache$Builder$maxSizePercent$lambda($percent, $context) {
    return function () {
      return numberToLong($percent * toNumber(totalAvailableMemoryBytes($context)));
    };
  }
  function Builder_3() {
    this.hxd_1 = null;
    this.ixd_1 = true;
    this.jxd_1 = true;
  }
  protoOf(Builder_3).sxi = function (context, percent) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.require' call
    if (!(0.0 <= percent ? percent <= 1.0 : false)) {
      var message = 'percent must be in the range [0.0, 1.0].';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var tmp = this;
    tmp.hxd_1 = MemoryCache$Builder$maxSizePercent$lambda(percent, context);
    return this;
  };
  protoOf(Builder_3).kxd = function (context, percent, $super) {
    percent = percent === VOID ? defaultMemoryCacheSizePercent(context) : percent;
    return $super === VOID ? this.sxi(context, percent) : $super.sxi.call(this, context, percent);
  };
  protoOf(Builder_3).g3d = function () {
    var tmp;
    if (this.jxd_1) {
      tmp = new RealWeakMemoryCache();
    } else {
      tmp = new EmptyWeakMemoryCache();
    }
    var weakMemoryCache = tmp;
    var tmp_0;
    if (this.ixd_1) {
      var tmp0 = this.hxd_1;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          var message = 'maxSizeBytesFactory == null';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp$ret$0 = tmp0;
          break $l$block;
        }
      }
      var maxSizeBytesFactory = tmp$ret$0;
      var maxSizeBytes = maxSizeBytesFactory();
      tmp_0 = new RealStrongMemoryCache(maxSizeBytes, weakMemoryCache);
    } else {
      tmp_0 = new EmptyStrongMemoryCache(weakMemoryCache);
    }
    var strongMemoryCache = tmp_0;
    return new RealMemoryCache(strongMemoryCache, weakMemoryCache);
  };
  function Companion_4() {
    this.txi_1 = 'MemoryCacheService';
    this.uxi_1 = 'coil#size';
    this.vxi_1 = 'coil#is_sampled';
    this.wxi_1 = 'coil#disk_cache_key';
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function MemoryCacheService(imageLoader, requestService, logger) {
    this.xxi_1 = imageLoader;
    this.yxi_1 = requestService;
    this.zxi_1 = logger;
  }
  function RealMemoryCache(strongMemoryCache, weakMemoryCache) {
    this.axj_1 = strongMemoryCache;
    this.bxj_1 = weakMemoryCache;
    this.cxj_1 = new Object();
  }
  function RealStrongMemoryCache$cache$1(this$0) {
    this.gxj_1 = this$0;
    LruCache.call(this, this$0.hxj_1);
  }
  function RealStrongMemoryCache(initialMaxSize, weakMemoryCache) {
    this.hxj_1 = initialMaxSize;
    this.ixj_1 = weakMemoryCache;
    var tmp = this;
    tmp.jxj_1 = new RealStrongMemoryCache$cache$1(this);
  }
  function EmptyStrongMemoryCache(weakMemoryCache) {
    this.kxj_1 = weakMemoryCache;
    this.lxj_1 = new Long(0, 0);
  }
  function Companion_5() {
    this.mxj_1 = 10;
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function RealWeakMemoryCache() {
    this.nxj_1 = LinkedHashMap_init_$Create$();
    this.oxj_1 = 0;
  }
  function EmptyWeakMemoryCache() {
  }
  var CachePolicy_ENABLED_instance;
  var CachePolicy_READ_ONLY_instance;
  var CachePolicy_WRITE_ONLY_instance;
  var CachePolicy_DISABLED_instance;
  var CachePolicy_entriesInitialized;
  function CachePolicy_initEntries() {
    if (CachePolicy_entriesInitialized)
      return Unit_instance;
    CachePolicy_entriesInitialized = true;
    CachePolicy_ENABLED_instance = new CachePolicy('ENABLED', 0, true, true);
    CachePolicy_READ_ONLY_instance = new CachePolicy('READ_ONLY', 1, true, false);
    CachePolicy_WRITE_ONLY_instance = new CachePolicy('WRITE_ONLY', 2, false, true);
    CachePolicy_DISABLED_instance = new CachePolicy('DISABLED', 3, false, false);
  }
  function CachePolicy(name, ordinal, readEnabled, writeEnabled) {
    Enum.call(this, name, ordinal);
    this.rxj_1 = readEnabled;
    this.sxj_1 = writeEnabled;
  }
  function CachePolicy_ENABLED_getInstance() {
    CachePolicy_initEntries();
    return CachePolicy_ENABLED_instance;
  }
  function CachePolicy_DISABLED_getInstance() {
    CachePolicy_initEntries();
    return CachePolicy_DISABLED_instance;
  }
  function Companion_6() {
    Companion_instance_6 = this;
    this.gxd_1 = new Defaults();
  }
  var Companion_instance_6;
  function Companion_getInstance_6() {
    if (Companion_instance_6 == null)
      new Companion_6();
    return Companion_instance_6;
  }
  function Defaults(fileSystem, interceptorCoroutineContext, fetcherCoroutineContext, decoderCoroutineContext, memoryCachePolicy, diskCachePolicy, networkCachePolicy, placeholderFactory, errorFactory, fallbackFactory, sizeResolver, scale, precision, extras) {
    Companion_getInstance_6();
    fileSystem = fileSystem === VOID ? defaultFileSystem() : fileSystem;
    interceptorCoroutineContext = interceptorCoroutineContext === VOID ? EmptyCoroutineContext_getInstance() : interceptorCoroutineContext;
    fetcherCoroutineContext = fetcherCoroutineContext === VOID ? ioCoroutineDispatcher() : fetcherCoroutineContext;
    decoderCoroutineContext = decoderCoroutineContext === VOID ? ioCoroutineDispatcher() : decoderCoroutineContext;
    memoryCachePolicy = memoryCachePolicy === VOID ? CachePolicy_ENABLED_getInstance() : memoryCachePolicy;
    diskCachePolicy = diskCachePolicy === VOID ? CachePolicy_ENABLED_getInstance() : diskCachePolicy;
    networkCachePolicy = networkCachePolicy === VOID ? CachePolicy_ENABLED_getInstance() : networkCachePolicy;
    placeholderFactory = placeholderFactory === VOID ? get_EMPTY_IMAGE_FACTORY() : placeholderFactory;
    errorFactory = errorFactory === VOID ? get_EMPTY_IMAGE_FACTORY() : errorFactory;
    fallbackFactory = fallbackFactory === VOID ? get_EMPTY_IMAGE_FACTORY() : fallbackFactory;
    sizeResolver = sizeResolver === VOID ? Companion_getInstance_8().txj_1 : sizeResolver;
    scale = scale === VOID ? Scale_FIT_getInstance() : scale;
    precision = precision === VOID ? Precision_EXACT_getInstance() : precision;
    extras = extras === VOID ? Companion_getInstance_0().uxc_1 : extras;
    this.pxd_1 = fileSystem;
    this.qxd_1 = interceptorCoroutineContext;
    this.rxd_1 = fetcherCoroutineContext;
    this.sxd_1 = decoderCoroutineContext;
    this.txd_1 = memoryCachePolicy;
    this.uxd_1 = diskCachePolicy;
    this.vxd_1 = networkCachePolicy;
    this.wxd_1 = placeholderFactory;
    this.xxd_1 = errorFactory;
    this.yxd_1 = fallbackFactory;
    this.zxd_1 = sizeResolver;
    this.axe_1 = scale;
    this.bxe_1 = precision;
    this.cxe_1 = extras;
  }
  protoOf(Defaults).uxj = function (fileSystem, interceptorCoroutineContext, fetcherCoroutineContext, decoderCoroutineContext, memoryCachePolicy, diskCachePolicy, networkCachePolicy, placeholderFactory, errorFactory, fallbackFactory, sizeResolver, scale, precision, extras) {
    return new Defaults(fileSystem, interceptorCoroutineContext, fetcherCoroutineContext, decoderCoroutineContext, memoryCachePolicy, diskCachePolicy, networkCachePolicy, placeholderFactory, errorFactory, fallbackFactory, sizeResolver, scale, precision, extras);
  };
  protoOf(Defaults).dxe = function (fileSystem, interceptorCoroutineContext, fetcherCoroutineContext, decoderCoroutineContext, memoryCachePolicy, diskCachePolicy, networkCachePolicy, placeholderFactory, errorFactory, fallbackFactory, sizeResolver, scale, precision, extras, $super) {
    fileSystem = fileSystem === VOID ? this.pxd_1 : fileSystem;
    interceptorCoroutineContext = interceptorCoroutineContext === VOID ? this.qxd_1 : interceptorCoroutineContext;
    fetcherCoroutineContext = fetcherCoroutineContext === VOID ? this.rxd_1 : fetcherCoroutineContext;
    decoderCoroutineContext = decoderCoroutineContext === VOID ? this.sxd_1 : decoderCoroutineContext;
    memoryCachePolicy = memoryCachePolicy === VOID ? this.txd_1 : memoryCachePolicy;
    diskCachePolicy = diskCachePolicy === VOID ? this.uxd_1 : diskCachePolicy;
    networkCachePolicy = networkCachePolicy === VOID ? this.vxd_1 : networkCachePolicy;
    placeholderFactory = placeholderFactory === VOID ? this.wxd_1 : placeholderFactory;
    errorFactory = errorFactory === VOID ? this.xxd_1 : errorFactory;
    fallbackFactory = fallbackFactory === VOID ? this.yxd_1 : fallbackFactory;
    sizeResolver = sizeResolver === VOID ? this.zxd_1 : sizeResolver;
    scale = scale === VOID ? this.axe_1 : scale;
    precision = precision === VOID ? this.bxe_1 : precision;
    extras = extras === VOID ? this.cxe_1 : extras;
    return $super === VOID ? this.uxj(fileSystem, interceptorCoroutineContext, fetcherCoroutineContext, decoderCoroutineContext, memoryCachePolicy, diskCachePolicy, networkCachePolicy, placeholderFactory, errorFactory, fallbackFactory, sizeResolver, scale, precision, extras) : $super.uxj.call(this, fileSystem, interceptorCoroutineContext, fetcherCoroutineContext, decoderCoroutineContext, memoryCachePolicy, diskCachePolicy, networkCachePolicy, placeholderFactory, errorFactory, fallbackFactory, sizeResolver, scale, precision, extras);
  };
  protoOf(Defaults).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Defaults))
      return false;
    if (!equals(this.pxd_1, other.pxd_1))
      return false;
    if (!equals(this.qxd_1, other.qxd_1))
      return false;
    if (!equals(this.rxd_1, other.rxd_1))
      return false;
    if (!equals(this.sxd_1, other.sxd_1))
      return false;
    if (!this.txd_1.equals(other.txd_1))
      return false;
    if (!this.uxd_1.equals(other.uxd_1))
      return false;
    if (!this.vxd_1.equals(other.vxd_1))
      return false;
    if (!equals(this.wxd_1, other.wxd_1))
      return false;
    if (!equals(this.xxd_1, other.xxd_1))
      return false;
    if (!equals(this.yxd_1, other.yxd_1))
      return false;
    if (!equals(this.zxd_1, other.zxd_1))
      return false;
    if (!this.axe_1.equals(other.axe_1))
      return false;
    if (!this.bxe_1.equals(other.bxe_1))
      return false;
    if (!this.cxe_1.equals(other.cxe_1))
      return false;
    return true;
  };
  protoOf(Defaults).hashCode = function () {
    var result = hashCode(this.pxd_1);
    result = imul(result, 31) + hashCode(this.qxd_1) | 0;
    result = imul(result, 31) + hashCode(this.rxd_1) | 0;
    result = imul(result, 31) + hashCode(this.sxd_1) | 0;
    result = imul(result, 31) + this.txd_1.hashCode() | 0;
    result = imul(result, 31) + this.uxd_1.hashCode() | 0;
    result = imul(result, 31) + this.vxd_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.wxd_1) | 0;
    result = imul(result, 31) + hashCode(this.xxd_1) | 0;
    result = imul(result, 31) + hashCode(this.yxd_1) | 0;
    result = imul(result, 31) + hashCode(this.zxd_1) | 0;
    result = imul(result, 31) + this.axe_1.hashCode() | 0;
    result = imul(result, 31) + this.bxe_1.hashCode() | 0;
    result = imul(result, 31) + this.cxe_1.hashCode() | 0;
    return result;
  };
  protoOf(Defaults).toString = function () {
    return 'Defaults(fileSystem=' + toString(this.pxd_1) + ', interceptorCoroutineContext=' + toString(this.qxd_1) + ', fetcherCoroutineContext=' + toString(this.rxd_1) + ', decoderCoroutineContext=' + toString(this.sxd_1) + ', memoryCachePolicy=' + this.txd_1.toString() + ', diskCachePolicy=' + this.uxd_1.toString() + ', networkCachePolicy=' + this.vxd_1.toString() + ', placeholderFactory=' + toString(this.wxd_1) + ', errorFactory=' + toString(this.xxd_1) + ', fallbackFactory=' + toString(this.yxd_1) + ', sizeResolver=' + toString(this.zxd_1) + ', scale=' + this.axe_1.toString() + ', precision=' + this.bxe_1.toString() + ', extras=' + this.cxe_1.toString() + ')';
  };
  var transformationsKey;
  var maxBitmapSizeKey;
  var addLastModifiedToFileCacheKeyKey;
  var allowConversionToBitmapKey;
  function crossfade(_this__u8e3s4, enable) {
    _init_properties_imageRequests_kt__vz1wml();
    return crossfade_0(_this__u8e3s4, enable ? 200 : 0);
  }
  var properties_initialized_imageRequests_kt_62wmpb;
  function _init_properties_imageRequests_kt__vz1wml() {
    if (!properties_initialized_imageRequests_kt_62wmpb) {
      properties_initialized_imageRequests_kt_62wmpb = true;
      transformationsKey = new Key(emptyList());
      maxBitmapSizeKey = new Key(Size_0(4096, 4096));
      addLastModifiedToFileCacheKeyKey = new Key(false);
      allowConversionToBitmapKey = new Key(true);
    }
  }
  function _Pixels___init__impl__qgjjfw(px) {
    // Inline function 'kotlin.require' call
    if (!(_Pixels___get_px__impl__uix9dv(px) > 0)) {
      var message = 'px must be > 0.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return px;
  }
  function _Pixels___get_px__impl__uix9dv($this) {
    return $this;
  }
  function Pixels__toString_impl_9ua830($this) {
    return 'Pixels(px=' + $this + ')';
  }
  function Pixels__hashCode_impl_vlg4vv($this) {
    return $this;
  }
  function Pixels__equals_impl_g64au9($this, other) {
    if (!(other instanceof Pixels))
      return false;
    if (!($this === other.vxj_1))
      return false;
    return true;
  }
  function Pixels(px) {
    this.vxj_1 = px;
  }
  protoOf(Pixels).toString = function () {
    return Pixels__toString_impl_9ua830(this.vxj_1);
  };
  protoOf(Pixels).hashCode = function () {
    return Pixels__hashCode_impl_vlg4vv(this.vxj_1);
  };
  protoOf(Pixels).equals = function (other) {
    return Pixels__equals_impl_g64au9(this.vxj_1, other);
  };
  function Undefined() {
  }
  protoOf(Undefined).toString = function () {
    return 'Undefined';
  };
  protoOf(Undefined).hashCode = function () {
    return -2093724603;
  };
  protoOf(Undefined).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Undefined))
      return false;
    return true;
  };
  var Undefined_instance;
  function Undefined_getInstance() {
    return Undefined_instance;
  }
  function Dimension(px) {
    return _Pixels___init__impl__qgjjfw(px);
  }
  var Precision_EXACT_instance;
  var Precision_INEXACT_instance;
  var Precision_entriesInitialized;
  function Precision_initEntries() {
    if (Precision_entriesInitialized)
      return Unit_instance;
    Precision_entriesInitialized = true;
    Precision_EXACT_instance = new Precision('EXACT', 0);
    Precision_INEXACT_instance = new Precision('INEXACT', 1);
  }
  function Precision(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Precision_EXACT_getInstance() {
    Precision_initEntries();
    return Precision_EXACT_instance;
  }
  function RealSizeResolver(size) {
    this.wxj_1 = size;
  }
  protoOf(RealSizeResolver).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealSizeResolver))
      return false;
    if (!this.wxj_1.equals(other.wxj_1))
      return false;
    return true;
  };
  protoOf(RealSizeResolver).hashCode = function () {
    return this.wxj_1.hashCode();
  };
  protoOf(RealSizeResolver).toString = function () {
    return 'RealSizeResolver(size=' + this.wxj_1.toString() + ')';
  };
  var Scale_FILL_instance;
  var Scale_FIT_instance;
  var Scale_entriesInitialized;
  function Scale_initEntries() {
    if (Scale_entriesInitialized)
      return Unit_instance;
    Scale_entriesInitialized = true;
    Scale_FILL_instance = new Scale('FILL', 0);
    Scale_FIT_instance = new Scale('FIT', 1);
  }
  function Scale(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Scale_FIT_getInstance() {
    Scale_initEntries();
    return Scale_FIT_instance;
  }
  function Companion_7() {
    Companion_instance_7 = this;
    this.xxj_1 = new Size(Undefined_instance, Undefined_instance);
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    if (Companion_instance_7 == null)
      new Companion_7();
    return Companion_instance_7;
  }
  function Size(width, height) {
    Companion_getInstance_7();
    this.yxj_1 = width;
    this.zxj_1 = height;
  }
  protoOf(Size).toString = function () {
    return 'Size(width=' + toString(this.yxj_1) + ', height=' + toString(this.zxj_1) + ')';
  };
  protoOf(Size).hashCode = function () {
    var result = hashCode(this.yxj_1);
    result = imul(result, 31) + hashCode(this.zxj_1) | 0;
    return result;
  };
  protoOf(Size).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Size))
      return false;
    if (!equals(this.yxj_1, other.yxj_1))
      return false;
    if (!equals(this.zxj_1, other.zxj_1))
      return false;
    return true;
  };
  function Size_0(width, height) {
    return new Size(new Pixels(Dimension(width)), new Pixels(Dimension(height)));
  }
  function Companion_8() {
    Companion_instance_8 = this;
    this.txj_1 = SizeResolver(Companion_getInstance_7().xxj_1);
  }
  var Companion_instance_8;
  function Companion_getInstance_8() {
    if (Companion_instance_8 == null)
      new Companion_8();
    return Companion_instance_8;
  }
  function SizeResolver(size) {
    return new RealSizeResolver(size);
  }
  function LruCache(maxSize) {
    this.axk_1 = LruMutableMap();
    this.bxk_1 = maxSize;
    this.cxk_1 = new Long(0, 0);
    // Inline function 'kotlin.require' call
    if (!(compare(maxSize, new Long(0, 0)) > 0)) {
      var message = 'maxSize <= 0';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  }
  function FetcherServiceLoaderTarget() {
  }
  function DecoderServiceLoaderTarget() {
  }
  var Level_Verbose_instance;
  var Level_Debug_instance;
  var Level_Info_instance;
  var Level_Warn_instance;
  var Level_Error_instance;
  var Level_entriesInitialized;
  function Level_initEntries() {
    if (Level_entriesInitialized)
      return Unit_instance;
    Level_entriesInitialized = true;
    Level_Verbose_instance = new Level('Verbose', 0);
    Level_Debug_instance = new Level('Debug', 1);
    Level_Info_instance = new Level('Info', 2);
    Level_Warn_instance = new Level('Warn', 3);
    Level_Error_instance = new Level('Error', 4);
  }
  function Level(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Level_Debug_getInstance() {
    Level_initEntries();
    return Level_Debug_instance;
  }
  function Level_Error_getInstance() {
    Level_initEntries();
    return Level_Error_instance;
  }
  function log(_this__u8e3s4, tag, throwable) {
    if (_this__u8e3s4.exk().i3(Level_Error_getInstance()) <= 0) {
      _this__u8e3s4.dxk(tag, Level_Error_getInstance(), null, throwable);
    }
  }
  function DebugLogger(minLevel) {
    minLevel = minLevel === VOID ? Level_Debug_getInstance() : minLevel;
    this.fxk_1 = minLevel;
  }
  protoOf(DebugLogger).exk = function () {
    return this.fxk_1;
  };
  protoOf(DebugLogger).dxk = function (tag, level, message, throwable) {
    if (!(message == null)) {
      println_0(level, tag, message);
    }
    if (!(throwable == null)) {
      println_0(level, tag, stackTraceToString(throwable));
    }
  };
  function get_EMPTY_IMAGE_FACTORY() {
    _init_properties_utils_kt__i7zv1b();
    return EMPTY_IMAGE_FACTORY;
  }
  var EMPTY_IMAGE_FACTORY;
  function get_dispatcher(_this__u8e3s4) {
    _init_properties_utils_kt__i7zv1b();
    var tmp = _this__u8e3s4.aa(Key_instance_0);
    return tmp instanceof CoroutineDispatcher ? tmp : null;
  }
  function EMPTY_IMAGE_FACTORY$lambda(it) {
    _init_properties_utils_kt__i7zv1b();
    return null;
  }
  var properties_initialized_utils_kt_wt0odb;
  function _init_properties_utils_kt__i7zv1b() {
    if (!properties_initialized_utils_kt_wt0odb) {
      properties_initialized_utils_kt_wt0odb = true;
      EMPTY_IMAGE_FACTORY = EMPTY_IMAGE_FACTORY$lambda;
    }
  }
  function singletonDiskCache() {
    return null;
  }
  function ioCoroutineDispatcher() {
    return Dispatchers_getInstance().i1h_1;
  }
  function defaultFileSystem() {
    return ThrowingFileSystem_getInstance();
  }
  function throwReadWriteIsUnsupported($this) {
    throw UnsupportedOperationException_init_$Create$("Javascript does not have access to the device's file system and cannot read from or write to it. If you are running on Node.js use 'NodeJsFileSystem' instead.");
  }
  function ThrowingFileSystem() {
    ThrowingFileSystem_instance = this;
    FileSystem.call(this);
  }
  protoOf(ThrowingFileSystem).kvp = function (source, target) {
    throwReadWriteIsUnsupported(this);
  };
  protoOf(ThrowingFileSystem).ivp = function (dir, mustCreate) {
    throwReadWriteIsUnsupported(this);
  };
  protoOf(ThrowingFileSystem).lvp = function (path, mustExist) {
    throwReadWriteIsUnsupported(this);
  };
  protoOf(ThrowingFileSystem).dvp = function (path) {
    throwReadWriteIsUnsupported(this);
  };
  protoOf(ThrowingFileSystem).fvp = function (file, mustCreate) {
    throwReadWriteIsUnsupported(this);
  };
  protoOf(ThrowingFileSystem).gvp = function (file, mustExist) {
    throwReadWriteIsUnsupported(this);
  };
  protoOf(ThrowingFileSystem).evp = function (file) {
    throwReadWriteIsUnsupported(this);
  };
  var ThrowingFileSystem_instance;
  function ThrowingFileSystem_getInstance() {
    if (ThrowingFileSystem_instance == null)
      new ThrowingFileSystem();
    return ThrowingFileSystem_instance;
  }
  function sam$coil3_EventListener_Factory$0(function_0) {
    this.gxk_1 = function_0;
  }
  protoOf(sam$coil3_EventListener_Factory$0).q3 = function () {
    return this.gxk_1;
  };
  protoOf(sam$coil3_EventListener_Factory$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Factory_3) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$coil3_EventListener_Factory$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function EventListener$Factory$Companion$NONE$lambda(it) {
    return Companion_getInstance_10().hxk_1;
  }
  function Companion_9() {
    Companion_instance_9 = this;
    var tmp = this;
    var tmp_0 = EventListener$Factory$Companion$NONE$lambda;
    tmp.hxe_1 = new sam$coil3_EventListener_Factory$0(tmp_0);
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  function EventListener$Companion$NONE$1() {
    EventListener.call(this);
  }
  function Factory_3() {
  }
  function Companion_10() {
    Companion_instance_10 = this;
    var tmp = this;
    tmp.hxk_1 = new EventListener$Companion$NONE$1();
  }
  var Companion_instance_10;
  function Companion_getInstance_10() {
    if (Companion_instance_10 == null)
      new Companion_10();
    return Companion_instance_10;
  }
  function EventListener() {
    Companion_getInstance_10();
  }
  function addAndroidComponents(_this__u8e3s4, options) {
    return _this__u8e3s4.oxc(new Factory_4());
  }
  function Factory_4() {
  }
  function RequestService(imageLoader, systemCallbacks, logger) {
    return new NonAndroidRequestService(imageLoader);
  }
  function NonAndroidRequestService(imageLoader) {
    this.ixk_1 = imageLoader;
  }
  function get_crossfadeMillisKey() {
    _init_properties_imageRequests_nonAndroid_kt__ajkwf();
    return crossfadeMillisKey;
  }
  var crossfadeMillisKey;
  function crossfade_0(_this__u8e3s4, durationMillis) {
    _init_properties_imageRequests_nonAndroid_kt__ajkwf();
    // Inline function 'kotlin.apply' call
    _this__u8e3s4.fxd_1.txc(get_crossfadeMillisKey(), durationMillis);
    return _this__u8e3s4;
  }
  var properties_initialized_imageRequests_nonAndroid_kt_c4j4qb;
  function _init_properties_imageRequests_nonAndroid_kt__ajkwf() {
    if (!properties_initialized_imageRequests_nonAndroid_kt_c4j4qb) {
      properties_initialized_imageRequests_nonAndroid_kt_c4j4qb = true;
      crossfadeMillisKey = new Key(0);
    }
  }
  function SystemCallbacks(imageLoader) {
    return new NoopSystemCallbacks();
  }
  function NoopSystemCallbacks() {
  }
  function get_application(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  function defaultMemoryCacheSizePercent(_this__u8e3s4) {
    return 0.15;
  }
  function totalAvailableMemoryBytes(_this__u8e3s4) {
    return new Long(536870912, 0);
  }
  function println_0(level, tag, message) {
    println(message);
  }
  function addAppleComponents(_this__u8e3s4, options) {
    return _this__u8e3s4;
  }
  function addJvmComponents(_this__u8e3s4, options) {
    return _this__u8e3s4;
  }
  function ServiceLoaderComponentRegistry() {
    ServiceLoaderComponentRegistry_instance = this;
    this.bxf_1 = new Object();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.cxf_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.dxf_1 = ArrayList_init_$Create$();
  }
  protoOf(ServiceLoaderComponentRegistry).exf = function () {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.bxf_1;
    return toImmutableList(ServiceLoaderComponentRegistry_getInstance().cxf_1);
  };
  protoOf(ServiceLoaderComponentRegistry).jxf = function () {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.bxf_1;
    return toImmutableList(ServiceLoaderComponentRegistry_getInstance().dxf_1);
  };
  protoOf(ServiceLoaderComponentRegistry).jxk = function (fetcher) {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.bxf_1;
    // Inline function 'kotlin.collections.plusAssign' call
    ServiceLoaderComponentRegistry_getInstance().cxf_1.j1(fetcher);
    return Unit_instance;
  };
  var ServiceLoaderComponentRegistry_instance;
  function ServiceLoaderComponentRegistry_getInstance() {
    if (ServiceLoaderComponentRegistry_instance == null)
      new ServiceLoaderComponentRegistry();
    return ServiceLoaderComponentRegistry_instance;
  }
  function toImmutableMap(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.r()) {
      tmp = emptyMap();
    } else {
      if (_this__u8e3s4 instanceof ImmutableMap) {
        tmp = _this__u8e3s4;
      } else {
        tmp = new ImmutableMap(LinkedHashMap_init_$Create$_0(_this__u8e3s4));
      }
    }
    return tmp;
  }
  function LruMutableMap(initialCapacity, loadFactor) {
    initialCapacity = initialCapacity === VOID ? 0 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    return new LruMutableMap_0(LinkedHashMap_init_$Create$_1(initialCapacity, loadFactor));
  }
  function toImmutableList(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.r()) {
      tmp = emptyList();
    } else {
      if (_this__u8e3s4 instanceof ImmutableList) {
        tmp = _this__u8e3s4;
      } else {
        tmp = new ImmutableList(ArrayList_init_$Create$_0(_this__u8e3s4));
      }
    }
    return tmp;
  }
  function ImmutableEntry(delegate) {
    this.kxk_1 = delegate;
  }
  protoOf(ImmutableEntry).equals = function (other) {
    return equals(this.kxk_1, other);
  };
  protoOf(ImmutableEntry).hashCode = function () {
    return hashCode(this.kxk_1);
  };
  protoOf(ImmutableEntry).toString = function () {
    return toString(this.kxk_1);
  };
  protoOf(ImmutableEntry).t1 = function () {
    return this.kxk_1.t1();
  };
  protoOf(ImmutableEntry).u1 = function () {
    return this.kxk_1.u1();
  };
  function ImmutableMap(delegate) {
    this.lxk_1 = delegate;
  }
  protoOf(ImmutableMap).s1 = function () {
    var tmp0 = this.lxk_1.s1();
    // Inline function 'kotlin.collections.mutableSetOf' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = LinkedHashSet_init_$Create$();
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var tmp$ret$2 = new ImmutableEntry(item);
      destination.j1(tmp$ret$2);
    }
    return destination;
  };
  protoOf(ImmutableMap).equals = function (other) {
    return equals(this.lxk_1, other);
  };
  protoOf(ImmutableMap).hashCode = function () {
    return hashCode(this.lxk_1);
  };
  protoOf(ImmutableMap).toString = function () {
    return toString(this.lxk_1);
  };
  protoOf(ImmutableMap).r = function () {
    return this.lxk_1.r();
  };
  protoOf(ImmutableMap).u2 = function (key) {
    return this.lxk_1.u2(key);
  };
  protoOf(ImmutableMap).v2 = function (value) {
    return this.lxk_1.v2(value);
  };
  protoOf(ImmutableMap).w2 = function (key) {
    return this.lxk_1.w2(key);
  };
  protoOf(ImmutableMap).n1 = function () {
    return this.lxk_1.n1();
  };
  protoOf(ImmutableMap).x2 = function () {
    return this.lxk_1.x2();
  };
  protoOf(ImmutableMap).y2 = function () {
    return this.lxk_1.y2();
  };
  function MutableEntry_0($outer, delegate) {
    this.nxk_1 = $outer;
    this.mxk_1 = delegate;
  }
  protoOf(MutableEntry_0).t1 = function () {
    return this.mxk_1.t1();
  };
  protoOf(MutableEntry_0).u1 = function () {
    return this.mxk_1.u1();
  };
  function LruMutableMap_0(delegate) {
    this.oxk_1 = delegate;
  }
  protoOf(LruMutableMap_0).s1 = function () {
    var tmp0 = this.oxk_1.s1();
    // Inline function 'kotlin.collections.mutableSetOf' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = LinkedHashSet_init_$Create$();
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var tmp$ret$2 = new MutableEntry_0(this, item);
      destination.j1(tmp$ret$2);
    }
    return destination;
  };
  protoOf(LruMutableMap_0).iy = function (key) {
    var item = this.oxk_1.a3(key);
    if (!(item == null)) {
      // Inline function 'kotlin.collections.set' call
      this.oxk_1.z2(key, item);
    }
    return item;
  };
  protoOf(LruMutableMap_0).w2 = function (key) {
    if (!!(key == null))
      return null;
    return this.iy(!(key == null) ? key : THROW_CCE());
  };
  protoOf(LruMutableMap_0).ly = function (key, value) {
    var item = this.oxk_1.a3(key);
    // Inline function 'kotlin.collections.set' call
    this.oxk_1.z2(key, value);
    return item;
  };
  protoOf(LruMutableMap_0).z2 = function (key, value) {
    var tmp = !(key == null) ? key : THROW_CCE();
    return this.ly(tmp, !(value == null) ? value : THROW_CCE());
  };
  protoOf(LruMutableMap_0).b3 = function (from) {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = from.s1().t();
    while (_iterator__ex2g4s.u()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.v();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.t1();
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.u1();
      this.ly(key, value);
    }
  };
  protoOf(LruMutableMap_0).py = function (key) {
    return this.oxk_1.a3(key);
  };
  protoOf(LruMutableMap_0).a3 = function (key) {
    if (!!(key == null))
      return null;
    return this.py(!(key == null) ? key : THROW_CCE());
  };
  protoOf(LruMutableMap_0).c3 = function () {
    this.oxk_1.c3();
  };
  protoOf(LruMutableMap_0).x2 = function () {
    return this.oxk_1.x2();
  };
  protoOf(LruMutableMap_0).y2 = function () {
    return this.oxk_1.y2();
  };
  protoOf(LruMutableMap_0).r = function () {
    return this.oxk_1.r();
  };
  protoOf(LruMutableMap_0).pxk = function (key) {
    return this.oxk_1.u2(key);
  };
  protoOf(LruMutableMap_0).u2 = function (key) {
    if (!!(key == null))
      return false;
    return this.pxk(!(key == null) ? key : THROW_CCE());
  };
  protoOf(LruMutableMap_0).qxk = function (value) {
    return this.oxk_1.v2(value);
  };
  protoOf(LruMutableMap_0).v2 = function (value) {
    if (!!(value == null))
      return false;
    return this.qxk(!(value == null) ? value : THROW_CCE());
  };
  protoOf(LruMutableMap_0).n1 = function () {
    return this.oxk_1.n1();
  };
  function ImmutableIterator(delegate) {
    this.rxk_1 = delegate;
  }
  protoOf(ImmutableIterator).equals = function (other) {
    return equals(this.rxk_1, other);
  };
  protoOf(ImmutableIterator).hashCode = function () {
    return hashCode(this.rxk_1);
  };
  protoOf(ImmutableIterator).toString = function () {
    return toString(this.rxk_1);
  };
  protoOf(ImmutableIterator).v = function () {
    return this.rxk_1.v();
  };
  protoOf(ImmutableIterator).u = function () {
    return this.rxk_1.u();
  };
  function ImmutableListIterator(delegate) {
    this.sxk_1 = delegate;
  }
  protoOf(ImmutableListIterator).equals = function (other) {
    return equals(this.sxk_1, other);
  };
  protoOf(ImmutableListIterator).hashCode = function () {
    return hashCode(this.sxk_1);
  };
  protoOf(ImmutableListIterator).toString = function () {
    return toString(this.sxk_1);
  };
  protoOf(ImmutableListIterator).v = function () {
    return this.sxk_1.v();
  };
  protoOf(ImmutableListIterator).u = function () {
    return this.sxk_1.u();
  };
  protoOf(ImmutableListIterator).v4 = function () {
    return this.sxk_1.v4();
  };
  protoOf(ImmutableListIterator).x4 = function () {
    return this.sxk_1.x4();
  };
  protoOf(ImmutableListIterator).w4 = function () {
    return this.sxk_1.w4();
  };
  protoOf(ImmutableListIterator).y4 = function () {
    return this.sxk_1.y4();
  };
  function ImmutableList(delegate) {
    this.txk_1 = delegate;
  }
  protoOf(ImmutableList).t = function () {
    return new ImmutableIterator(this.txk_1.t());
  };
  protoOf(ImmutableList).p1 = function (index) {
    return new ImmutableListIterator(this.txk_1.p1(index));
  };
  protoOf(ImmutableList).equals = function (other) {
    return equals(this.txk_1, other);
  };
  protoOf(ImmutableList).hashCode = function () {
    return hashCode(this.txk_1);
  };
  protoOf(ImmutableList).toString = function () {
    return toString(this.txk_1);
  };
  protoOf(ImmutableList).r = function () {
    return this.txk_1.r();
  };
  protoOf(ImmutableList).lh = function (element) {
    return this.txk_1.m1(element);
  };
  protoOf(ImmutableList).m1 = function (element) {
    if (!true)
      return false;
    return this.lh(element);
  };
  protoOf(ImmutableList).mh = function (elements) {
    return this.txk_1.r2(elements);
  };
  protoOf(ImmutableList).r2 = function (elements) {
    return this.mh(elements);
  };
  protoOf(ImmutableList).l1 = function (index) {
    return this.txk_1.l1(index);
  };
  protoOf(ImmutableList).yz = function (element) {
    return this.txk_1.q1(element);
  };
  protoOf(ImmutableList).q1 = function (element) {
    if (!true)
      return -1;
    return this.yz(element);
  };
  protoOf(ImmutableList).t2 = function (fromIndex, toIndex) {
    return this.txk_1.t2(fromIndex, toIndex);
  };
  protoOf(ImmutableList).n1 = function () {
    return this.txk_1.n1();
  };
  function remainingFreeSpaceBytes(_this__u8e3s4, directory) {
    // Inline function 'kotlin.Long.times' call
    var this_0 = new Long(4, 0);
    // Inline function 'kotlin.Long.times' call
    var this_1 = multiply(this_0, fromInt(1024));
    // Inline function 'kotlin.Long.times' call
    var this_2 = multiply(this_1, fromInt(1024));
    return multiply(this_2, fromInt(1024));
  }
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_2 = new Companion_2();
  Companion_instance_3 = new Companion_3();
  Companion_instance_4 = new Companion_4();
  Companion_instance_5 = new Companion_5();
  Undefined_instance = new Undefined();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Builder_2;
  _.$_$.b = Builder_3;
  _.$_$.c = crossfade;
  _.$_$.d = DebugLogger;
  _.$_$.e = FetcherServiceLoaderTarget;
  _.$_$.f = Key;
  _.$_$.g = ImageLoader;
  _.$_$.h = Uri;
  _.$_$.i = ServiceLoaderComponentRegistry_getInstance;
  _.$_$.j = CachePolicy_DISABLED_getInstance;
  _.$_$.k = CachePolicy_ENABLED_getInstance;
  _.$_$.l = Builder_init_$Create$;
  _.$_$.m = Builder_init_$Create$_2;
  //endregion
  return _;
}));

//# sourceMappingURL=coil-root-coil-core.js.map
